import { useMutation } from '@tanstack/react-query';

import { weatherApi } from 'api/weather';

/**
 * Downloads a completed weather report CSV.
 *
 * @param {Omit<import('@tanstack/react-query').UseMutationOptions<void, Error, string | number>, 'mutationFn'>} [mutationOptions={]}
 * @returns {import('@tanstack/react-query').UseMutationResult<void, Error, string | number>}
 */
export function useDownloadWeatherReportMutation(mutationOptions = {}) {
    return useMutation({
        mutationFn: async (reportId) => {
            await weatherApi.downloadWeatherReport(reportId);
        },
        ...mutationOptions,
    });
}
